import { Link } from 'react-router-dom'

/**
 * Footer con info del club e link utili
 */
export default function Footer() {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="bg-night-light border-t border-gray-800 mt-auto">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Colonna 1 - Info */}
          <div>
            <div className="mb-4">
              <img
                src="/images/logo.png"
                alt="Conero Garage Approved"
                className="h-20 w-auto"
              />
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              La guida ai migliori locali delle Marche dove{' '}
              <span className="text-gold font-semibold">"Si Mangia Bene!"</span>
              <br />
              Certificati dagli appassionati del club 4x4 Conero Garage.
            </p>
          </div>

          {/* Colonna 2 - Link */}
          <div>
            <h4 className="font-display text-lg text-white mb-4">NAVIGAZIONE</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-gold transition-colors text-sm">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/locali" className="text-gray-400 hover:text-gold transition-colors text-sm">
                  Tutti i Locali
                </Link>
              </li>
              <li>
                <Link to="/come-funziona" className="text-gray-400 hover:text-gold transition-colors text-sm">
                  Come Funziona
                </Link>
              </li>
              <li>
                <Link to="/il-club" className="text-gray-400 hover:text-gold transition-colors text-sm">
                  Il Club
                </Link>
              </li>
            </ul>
          </div>

          {/* Colonna 3 - Contatti */}
          <div>
            <h4 className="font-display text-lg text-white mb-4">CONTATTI</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li className="flex items-center gap-2">
                <svg className="w-4 h-4 text-gold" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                <a href="mailto:info@conerogarage.it" className="hover:text-gold transition-colors">
                  info@conerogarage.it
                </a>
              </li>
              <li className="flex items-center gap-2">
                <svg className="w-4 h-4 text-gold" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
                </svg>
                <a
                  href="https://conerogarage.it"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-gold transition-colors"
                >
                  conerogarage.it
                </a>
              </li>
              <li className="flex items-center gap-2">
                <svg className="w-4 h-4 text-gold" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073z"/>
                </svg>
                <a
                  href="https://instagram.com/conerogarage"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-gold transition-colors"
                >
                  @conerogarage
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-12 pt-8 border-t border-gray-800 text-center">
          <p className="text-gray-500 text-sm">
            &copy; {currentYear} Conero Garage Approved. Tutti i diritti riservati.
          </p>
          <p className="text-gray-600 text-xs mt-2">
            Un progetto del club 4x4 Conero Garage - Marche, Italia
          </p>
        </div>
      </div>
    </footer>
  )
}
